export default __webpack_public_path__ + "static/media/CIO_Contractor_Site_Rates.d98f64e5.pdf";